export default __webpack_public_path__ + "static/media/subheader-tr.02f45d3e.png";